import * as React from 'react';
import * as FontAwesome from 'react-fontawesome';
import { connect, Dispatch } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { ApplicationState } from '../../data/applicationStates';
import { headerActionCreators } from '../../data/header/headerActions';
import { HeaderState } from '../../data/header/headerModels';
import { shipmentsActionCreators } from '../../data/shipment/shipmentAction';
import { ShipmentState } from '../../data/shipment/shipmentModels';
// import * as shortId from 'shortid';
// tslint:disable-next-line:no-var-requires
const moment = require('moment');
// require('moment/locale/sv');
// tslint:disable-next-line:no-var-requires
const shipmentsicon = require('../../resources/shipments.png');
import Table from '../../components/table/table';
import { DataType, RowObject, Tbody } from '../../components/table/tableModels';

interface LocalShipmentState {
    shipments: ShipmentState;
    header: HeaderState;
}

interface ShipmentAction {
    shipmentActions: typeof shipmentsActionCreators;
    headerActions: typeof headerActionCreators;
}

type ShipmentProps = LocalShipmentState & // ... state we've requested from the Redux store
    ShipmentAction & // ... plus action creators we've requested
    RouteComponentProps<{}>; // ... plus incoming routing parameters

interface State {
    tHead: Array<RowObject>;
    shipmentList: Array<Tbody>;
}

class Shipments extends React.Component<ShipmentProps, State> {
    constructor(props: ShipmentProps) {
        super(props);
        // this.renderOrders = this.renderOrders.bind(this);
        this.state = {
            tHead: [
                new RowObject(DataType.string, 'Shipping Date', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'Order Number', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'PO Number', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'Carrier', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'Ship To Name', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'Tracking Number', undefined, undefined, 'pointer')
                // new RowObject(DataType.string, 'Freight Charge', undefined, undefined, 'pointer')
            ],
            shipmentList: []
        };
    }

    componentWillMount() {
        this.props.headerActions.setBottomHeader('My Quick Solutions Online');
        this.getTbody(this.props);
    }

    componentDidUpdate(prevProps: ShipmentProps) {
        if (this.props.shipments.shipments !== prevProps.shipments.shipments) {
            this.getTbody(this.props);
        }
    }

    getTbody(props: ShipmentProps) {
        let ShipmentList = new Array<Tbody>();

        ShipmentList = props.shipments.shipments.map((data) => {
            const rBody = new Array<RowObject>();

            rBody.push(
                new RowObject(
                    DataType.string,
                    data.shipDate ? moment(data.shipDate, 'M/D/YYYY').format('M/D/YYYY') : '',
                    null,
                    undefined,
                    undefined
                )
            );

            rBody.push(
                new RowObject(DataType.string, data.orderNumber ? data.orderNumber : '', null, undefined, undefined)
            );

            rBody.push(new RowObject(DataType.string, data.pONumber ? data.pONumber : '', null, undefined, undefined));

            rBody.push(new RowObject(DataType.string, data.carrier ? data.carrier : '', null, undefined, undefined));

            rBody.push(
                new RowObject(DataType.string, data.shipToName ? data.shipToName : '', null, undefined, undefined)
            );

            rBody.push(
                new RowObject(DataType.string, data.trackNumber ? data.trackNumber : '', null, undefined, undefined)
            );
            /*    
            rBody.push(new RowObject(
                DataType.string,
                data.freightcharge ? data.freightcharge : '',
                null,
                undefined,
                undefined
            ));  
            */
            const row = new Tbody(rBody, data.shipmentId, this.openShipment.bind(this));

            return row;
        });
        this.setState({ shipmentList: ShipmentList });
    }

    openShipment(shipmentid: string) {
        this.props.history.push('/shipment/' + shipmentid);
    }

    public render() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="componentHeader">
                        <div className="item tile">
                            <div className="tileHead">
                                <div className="float-left">
                                    <h4>{'Shipments'}</h4>
                                </div>
                                <div className="tileImage float-right">{<img src={shipmentsicon} />}</div>
                            </div>
                            <div className="tileBody">
                                <div className="topBorder" />
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.shipmentList.length > 0 ? (
                    <Table
                        tHead={this.state.tHead}
                        tBody={this.state.shipmentList}
                        listSize={this.props.shipments.shipments.length}
                        hover={true}
                        cursor={true}
                        hidePagination={true}
                        americanDateFormat={true}
                    />
                ) : (
                    <div className="centerThis">
                        <FontAwesome className="progressicon" name="spinner" size="3x" spin={true} />
                    </div>
                )}
            </div>
        );
    }
}

export function mapStateToProps(state: ApplicationState): LocalShipmentState {
    return {
        shipments: state.shipments,
        header: state.header
    };
}

function mapDispatchToProps(dispatch: Dispatch<{}>): ShipmentAction {
    return {
        shipmentActions: bindActionCreators(shipmentsActionCreators, dispatch),
        headerActions: bindActionCreators(headerActionCreators, dispatch)
    };
}

export default withRouter(
    connect(
        mapStateToProps, // Selects which state properties are merged into the component's props
        mapDispatchToProps // Selects which action creators are merged into the component's props
    )(Shipments)
);



// WEBPACK FOOTER //
// ./src/containers/shipments/shipments.tsx